import { render, staticRenderFns } from "./ReportFormWrapBigNew.vue?vue&type=template&id=00d6e46c&scoped=true"
import script from "./ReportFormWrapBigNew.vue?vue&type=script&lang=js"
export * from "./ReportFormWrapBigNew.vue?vue&type=script&lang=js"
import style0 from "./ReportFormWrapBigNew.vue?vue&type=style&index=0&id=00d6e46c&prod&lang=stylus&scoped=true"
import style1 from "./ReportFormWrapBigNew.vue?vue&type=style&index=1&id=00d6e46c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d6e46c",
  null
  
)

export default component.exports